import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, sendPasswordResetEmail, updateProfile, onAuthStateChanged as firebaseOnAuthStateChanged, } from 'firebase/auth';
import { auth } from './config';
import { db } from './config';
import { doc, setDoc, getDoc } from 'firebase/firestore';
// Export Firebase Auth functions for use in other services
export { createUserWithEmailAndPassword, updateProfile, signInWithEmailAndPassword };
export const signUp = async (email, password, displayName) => {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    await updateProfile(userCredential.user, { displayName });
};
export const signIn = async (email, password) => {
    // Authenticate with Firebase Auth
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const token = await userCredential.user.getIdToken();
    if (typeof localStorage !== 'undefined')
        localStorage.setItem('token', token);
    // IMMEDIATELY check user status in Firestore BEFORE any other async operations
    // This must happen synchronously in the promise chain to ensure the error is thrown
    // before onAuthStateChanged processes the user
    const userDoc = await getDoc(doc(db, 'users', userCredential.user.uid));
    if (userDoc.exists()) {
        const userData = userDoc.data();
        const status = userData?.status;
        // Check if user is inactive
        if (status === 'inactive') {
            // Sign out the user immediately
            await signOut(auth);
            // Create error object with all properties
            const error = Object.assign(new Error('ACCOUNT_DEACTIVATED'), {
                code: 'auth/account-deactivated',
                name: 'AccountDeactivatedError',
                message: 'ACCOUNT_DEACTIVATED'
            });
            // CRITICAL: Throw the error immediately - this will reject the promise
            // and prevent the Login component from thinking sign-in succeeded
            throw error;
        }
    }
};
export const logOut = async () => {
    await signOut(auth);
};
export const resetPassword = async (email) => {
    await sendPasswordResetEmail(auth, email);
};
export const getCurrentUser = () => {
    return auth.currentUser;
};
export const onAuthStateChanged = (callback) => {
    return firebaseOnAuthStateChanged(auth, callback);
};
export const createSuperAdmin = async (email, password, displayName) => {
    try {
        // Create the user in Firebase Auth
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        // Update the user's profile
        await updateProfile(userCredential.user, { displayName });
        // Create the super admin document in Firestore
        await setDoc(doc(db, 'users', userCredential.user.uid), {
            email,
            displayName,
            role: 'super-admin',
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
        });
    }
    catch (error) {
        // If anything fails, we should clean up the auth user
        if (auth.currentUser) {
            await auth.currentUser.delete();
        }
        throw error;
    }
};
